import { RouteConfig, SideLink } from '@/types/utility.types'
import {
  IconBookmarkQuestion,
  IconUserQuestion,
  IconShoppingBagSearch,
  IconShoppingCartQuestion,
} from '@tabler/icons-react'

export const complaintAndSuggestionModuleKey = 'client_insight'
export const findCheaperOneModuleKey = 'cheaper_option_found'
export const wouldBuyModuleKey = 'would_buy'

const complaintAndSuggestionRoute: RouteConfig = {
  uid: complaintAndSuggestionModuleKey,
  path: 'requests/complaint-and-suggestion',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/requests/complaint-suggestion')).default,
  }),
}

const findCheaperOneRoute: RouteConfig = {
  uid: findCheaperOneModuleKey,
  path: 'requests/find-cheaper-one',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/requests/find-cheaper-one')).default,
  }),
}

const wouldBuyRoute: RouteConfig = {
  uid: wouldBuyModuleKey,
  path: 'requests/would-buy',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/requests/would-buy')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Requests',
  href: 'requests',
  icon: <IconBookmarkQuestion size={18} />,
  order: 6,
  sub: [
    {
      uid: wouldBuyModuleKey,
      title: 'Would buy',
      href: 'requests/would-buy',
      icon: <IconShoppingCartQuestion size={18} />,
      order: 1,
    },
    {
      uid: complaintAndSuggestionModuleKey,
      title: 'Complaints and Suggestions',
      href: 'requests/complaint-and-suggestion',
      icon: <IconUserQuestion size={18} />,
      order: 2,
    },
    {
      uid: findCheaperOneModuleKey,
      title: 'Find cheaper one?',
      href: 'requests/find-cheaper-one',
      icon: <IconShoppingBagSearch size={18} />,
      order: 3,
    },
  ],
}

export default [complaintAndSuggestionRoute, findCheaperOneRoute, wouldBuyRoute]
